<template>
  <div></div>
</template>

<script>
export default {
  name: 'DvRedirect',
  mounted() {
    window.location.href = '/api/ext/datagear-dv/'
  }
}
</script>
